import React, { useState } from 'react';
import { tagColors } from '../data/themes';

const COLS = ['new', 'meeting', 'nego', 'won', 'lost'];
const COL_TITLES = {
  new: 'New Prospect',
  meeting: 'Meeting',
  nego: 'Negotiation',
  won: 'Closed Won',
  lost: 'Closed Lost'
};

const PipelinePage = ({ active, leads, onAddLead, onDeleteLead, onMoveLead }) => {
  const [draggedId, setDraggedId] = useState(null);

  const handleDragStart = (e, id) => {
    setDraggedId(id);
    setTimeout(() => e.target.classList.add('dragging'), 0);
  };

  const handleDragEnd = (e) => {
    e.target.classList.remove('dragging');
    setDraggedId(null);
  };

  const handleDrop = (e, col) => {
    e.preventDefault();
    e.currentTarget.classList.remove('drag-over');
    if (draggedId !== null) {
      onMoveLead(draggedId, col);
    }
  };

  return (
    <section className={`section ${active ? 'active' : ''}`} data-testid="pipeline-section">
      <div className="section-header">
        <div>
          <div className="section-title">Lead Pipeline</div>
          <div className="section-subtitle">Drag & drop to update deal stages</div>
        </div>
        <button className="btn btn-gold" onClick={onAddLead} data-testid="open-add-lead-btn">+ Add Lead</button>
      </div>
      <div className="kanban-board">
        {COLS.map(col => (
          <div
            key={col}
            className={`kanban-col col-${col}`}
            onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
            onDragLeave={(e) => e.currentTarget.classList.remove('drag-over')}
            onDrop={(e) => handleDrop(e, col)}
            data-testid={`kanban-col-${col}`}
          >
            <div className="kanban-col-header">
              <span className="kanban-col-title">{COL_TITLES[col]}</span>
              <span className="kanban-count">{leads.filter(l => l.col === col).length}</span>
            </div>
            <div className="kanban-cards">
              {leads.filter(l => l.col === col).map(lead => (
                <div
                  key={lead.id}
                  className="lead-card"
                  draggable
                  onDragStart={(e) => handleDragStart(e, lead.id)}
                  onDragEnd={handleDragEnd}
                  data-testid={`lead-card-${lead.id}`}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2px' }}>
                    <div className="lead-card-name">{lead.name}</div>
                    <button
                      className="btn-icon-danger"
                      onClick={(e) => { e.stopPropagation(); e.preventDefault(); onDeleteLead(lead); }}
                      title="Hapus"
                      data-testid={`delete-lead-btn-${lead.id}`}
                    >✕</button>
                  </div>
                  <div className="lead-card-company">{lead.company}</div>
                  <div className="lead-card-footer">
                    <div className="lead-card-value">{lead.value}</div>
                    <div
                      className="lead-card-tag"
                      style={{
                        background: `${tagColors[lead.tag] || '#7F8C8D'}22`,
                        color: (tagColors[lead.tag] || '#7F8C8D'),
                        border: `1px solid ${tagColors[lead.tag] || '#7F8C8D'}44`
                      }}
                    >{lead.tag}</div>
                  </div>
                  {col === 'lost' && (
                    <div style={{
                      marginTop: '10px', padding: '6px 8px',
                      backgroundColor: 'rgba(212,175,55,0.1)',
                      border: '1px dashed rgba(212,175,55,0.3)',
                      borderRadius: '6px', fontSize: '10px',
                      color: 'var(--text-secondary)',
                      display: 'flex', alignItems: 'flex-start', gap: '6px'
                    }}>
                      <span style={{ color: 'var(--gold)', fontSize: '11px', marginTop: '1px' }}>⏳</span>
                      <span style={{ lineHeight: '1.4' }}>
                        <strong>Pengingat:</strong> Hubungi kembali dalam 3-6 bulan untuk <i>follow-up</i> peluang baru.
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PipelinePage;
